import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const generateReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/attendance_reports/attendance_record_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const generateAttendanceDetailReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/attendance_reports/attendance_detail_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const generateWorkedSundayReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/attendance_reports/worked_sunday_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const generateWorkedHolidayReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/attendance_reports/worked_holiday_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const generateMissingTimeReports = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/legalreports/missing_time_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const generateAttendanceSheetReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/legalreports/attendance_sheet_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const generateTelecommutingReport = ({  
    dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/telecommuting_reports/telecommuting_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const markingCorrectionReportRequest = ({  
    dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
ApiService.request(
    'get',
    `/marking_correction_reports/marking_correction_history_reports/generate_report${format || ''}`,
    {
      dispatch,
      params,
      responseType,
      successCallback,
      failureCallback,
      callback
    }
  );
};

export const debounceGenerateReport = AwesomeDebouncePromise(generateReport, 300);
export const debounceGenerateAttendanceDetailReport = AwesomeDebouncePromise(generateAttendanceDetailReport, 300);
export const debounceGenerateWorkedSundayReport = AwesomeDebouncePromise(generateWorkedSundayReport, 300);
export const debounceGenerateWorkedHolidayReport = AwesomeDebouncePromise(generateWorkedHolidayReport, 300);
export const debounceGenerateMissingTimeReports = AwesomeDebouncePromise(generateMissingTimeReports, 300);
export const debounceGenerateAttendanceSheetReport = AwesomeDebouncePromise(generateAttendanceSheetReport, 300);
export const debounceGenerateTelecommutingReport = AwesomeDebouncePromise(generateTelecommutingReport, 300);
export const debounceMarkingCorrectionReportRequest = AwesomeDebouncePromise(markingCorrectionReportRequest, 300);
